import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { BemHelper } from "utils/bemHelper";

import { useLazyChildRenderer } from "hooks/useLazyChildRenderer";

import { ReactComponent as Caret } from "assets/icons/caret.svg";

import "./Accordion.scss";

const noop = () => {};

const bem = new BemHelper("z-accordion");

export const Accordion = (props) => {
  const shouldRenderContent = useLazyChildRenderer(props.isOpen);

  const handleToggle = () => props.onToggle({ isOpen: !props.isOpen });

  const classNames = cx([
    bem.component,
    { "is-open": props.isOpen },
    { "is-closed": !props.isOpen },
  ]);

  return (
    <div className={classNames}>
      <button
        type="button"
        className={bem.for("trigger")}
        onClick={handleToggle}
        aria-expanded={props.isOpen}
        aria-controls={`${props.id}-content`}>
        <span className={bem.for("text")} dangerouslySetInnerHTML={{ __html: props.text }} />
        <Caret className={bem.for("icon")} />
      </button>
      {shouldRenderContent && (
        <div id={`${props.id}-content`} className={bem.for("content")}>
          {props.children}
        </div>
      )}
    </div>
  );
};

Accordion.propTypes = {
  text: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func,
};

Accordion.defaultProps = {
  isOpen: false,
  onToggle: noop,
};
